/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type { Signer, ContractDeployTransaction, ContractRunner } from "ethers";
import type { NonPayableOverrides } from "../../../../common";
import type {
  BondTeller,
  BondTellerInterface,
} from "../../../../contracts/test/BondTeller.mock.sol/BondTeller";

const _abi = [
  {
    inputs: [],
    name: "auct",
    outputs: [
      {
        internalType: "contract IBondAuctioneer",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient_",
        type: "address",
      },
      {
        internalType: "address",
        name: "referrer_",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id_",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount_",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "minAmountOut_",
        type: "uint256",
      },
    ],
    name: "purchase",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint48",
        name: "",
        type: "uint48",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IBondAuctioneer",
        name: "au",
        type: "address",
      },
    ],
    name: "setParams",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
] as const;

const _bytecode =
  "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";

type BondTellerConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: BondTellerConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class BondTeller__factory extends ContractFactory {
  constructor(...args: BondTellerConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(overrides || {});
  }
  override deploy(overrides?: NonPayableOverrides & { from?: string }) {
    return super.deploy(overrides || {}) as Promise<
      BondTeller & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(runner: ContractRunner | null): BondTeller__factory {
    return super.connect(runner) as BondTeller__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): BondTellerInterface {
    return new Interface(_abi) as BondTellerInterface;
  }
  static connect(address: string, runner?: ContractRunner | null): BondTeller {
    return new Contract(address, _abi, runner) as unknown as BondTeller;
  }
}
